import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import CachedDataService from '../../utilities/cached-data-service'

const cachedDataService = new CachedDataService()

const fetchData = ({
    offset=0,
    limit=20,
    name,
    dimensions = [],
    types = [],
}) => {
    let url = urlGenerator.learningResources()
    url = `${url}?limit=${limit}&offset=${offset}`
    if (name) {
        url = `${url}&n=${name}`
    }
    if (dimensions && dimensions.length) {
        url = `${url}&${dimensions.map(d => `d=${d}`).join('&')}`
    }
    if (types && types.length) {
        url = `${url}&${types.map(d => `t=${d}`).join('&')}`
    }
    return axios.get(url, createRequestConfig()).then(property('data'))
}

export default fetchData
export const clearCache = () => cachedDataService.clear()